import React from 'react';
import notFound from '../../layout/assets/page-misc-error-light.png';

const MiscError = () => {
    return (
        <div className="container-xxl container-p-y">
        <div className="misc-wrapper">
            <h2 className="mb-2 mx-2">Page non trouvé :(</h2>
            <p className="mb-4 mx-2">
            Oups ! 😖 L'URL demandée n'a pas été trouvée sur ce serveur.
            </p>
            <a href="/dashboard" className="btn btn-primary">
            <i className="bx bx-chevron-left bx-sm" />
            Retour à la page d'accueil
            </a>
            <div className="mt-3">
            <img
                src={notFound}
                alt="page-misc-error-light"
                width={500}
                className="img-fluid"
                data-app-dark-img="illustrations/page-misc-error-dark.png"
                data-app-light-img="illustrations/page-misc-error-light.png"
            />
            </div>
        </div>
        </div>

    );
}

export default MiscError;
